<template>
  <el-form
    :label-position="labelPosition"
    :label-width="labelWidthFilter"
    :model="model"
    :rules="rules"
    @submit.native.prevent="doFilter"
    class="filter"
    ref="form"
  >
    <el-row :gutter="16" class="filter__container"> 
      <!-- First Name -->
      <el-col :lg="6" :md="6" :sm="24">
        <el-form-item :prop="fields.firstName.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.firstName.label}}</span>
            <el-button v-if="model.firstName" type="text" @click="resetFieldFilter({ fieldKey: 'firstName'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-player"
            :placeholder="fields.firstName.label"
            v-model="model[fields.firstName.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col>

      <!-- Last Name -->
      <el-col :lg="6" :md="6" :sm="24">
        <el-form-item :prop="fields.lastName.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.lastName.label}}</span>
            <el-button v-if="model.lastName" type="text" @click="resetFieldFilter({ fieldKey: 'lastName'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-player"
            :placeholder="fields.lastName.label"
            v-model="model[fields.lastName.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col>

      <!-- Type -->
      <el-col :lg="5" :md="6" :sm="24">
        <el-form-item :prop="fields.type.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.type.label}}</span>
            <el-button v-if="model.type" type="text" @click="resetFieldFilter({ fieldKey: 'type'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-select
            :placeholder="fields.type.label"
            v-model="model[fields.type.name]"
            @change="doFilter"
          >
            <el-option :value="undefined">--</el-option>
            <i class="icon-cup" slot="prefix"></i>
            <el-option
              :key="option.id"
              :label="option.label"
              :value="option.id"
              v-for="option in fields.type.options"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>

      <!-- Email -->
      <el-col :lg="6" :md="6" :sm="24">
        <el-form-item :prop="fields.email.name">
          <div class="form__item__label__slot" slot="label">
            <span>{{fields.email.label}}</span>
            <el-button v-if="model.email" type="text" @click="resetFieldFilter({ fieldKey: 'email'})"><app-i18n code="common.reset"/></el-button>
          </div>
          <el-input
            clearable
            prefix-icon="icon-player"
            :placeholder="fields.email.label"
            v-model="model[fields.email.name]"
            @input.native="debounceInput"
            @clear="doFilter"
          />
        </el-form-item>
      </el-col>

      <!-- Filter buttons -->
      <el-col :lg="1" :md="1" :sm="24">
        <div class="filter-buttons">
          <el-button
            :disabled="loading"
            @click="doResetFilter"
            icon="icon-undo"
            circle
          />
        </div>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { FilterSchema } from '@shared/form/filter-schema';
import { CoachModel } from '@modules/coach/coach-model';
import _ from 'lodash';

export default {
  name: 'app-coach-list-filter',

  data() {
    return {
      model: {},
    };
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthFilter: 'layout/labelWidthFilter',
      loading: 'coach/list/loading',
      filter: 'coach/list/filter',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    rules() {
      const { filterSchema } = this;
      return filterSchema.rules();
    },
    
    filterSchema() {
      const { fields } = this;
      return new FilterSchema([
        fields.id,
        fields.firstName,
        fields.lastName,
        fields.type,
        fields.email,
      ]);
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new CoachModel({ dateFormat, timeFormat }).fields();
    },
  },

  async mounted() {
    const { filterSchema } = this; 
    this.model = filterSchema.initialValues(
      this.filter,
      this.$route.query,
    );
  },

  methods: {
    ...mapActions({
      doReset: 'coach/list/doReset',
      doFetch: 'coach/list/doFetch',
    }),

    async doResetFilter() {
      const { filterSchema } = this; 
      this.model = filterSchema.initialValues();
      this.$refs.form.clearValidate();
      return this.doReset();
    },

    async resetFieldFilter({ fieldKey }) {
      if (this.model[`${fieldKey}`]) this.model[`${fieldKey}`] = null;
      this.doFilter();
    },

    debounceInput: _.debounce(function () {
      this.doFilter();
    }, 500),

    async doFilter() {
      const { filterSchema } = this; 
      try {
        await this.$refs.form.validate();
        this.$refs.form.clearValidate();
      } catch (error) {
        return;
      }

      const filter = filterSchema.cast(this.model);
      return this.doFetch({
        filter,
      });
    },
  },
};
</script>

<style>
</style>
